module.exports = __webpack_public_path__ + "img/img012.de8c24ed.png";